import { errorHandlerType } from './ErrorMessage'

/** Handle form validation for the login form
 * @param username - user's auth username
 * @param password - user's auth password
 * @param setErrorMessage - function that handles updating error state value
 */
export const validateLoginForm = (
  username: string,
  password: string,
  setErrorMessage: (error: errorHandlerType | string | null) => void,
  setShowError: (show: boolean) => void
): boolean => {
  // Check for undefined or empty input fields
  if (!username || !password) {
    setErrorMessage({ message: 'Please enter a valid username and password.', level: 'ERROR' })
    setShowError(true)
    return false
  }
  return true
}
